import { useEffect } from "react"
import { signOut } from "firebase/auth"
import { auth } from "../../helpers"
import nookies from "nookies"

const OPEN_TABS_KEY = "open_tabs_count"
const TAB_ID_KEY = "tab_id"

export function useBrowserSessionGuard() {
  useEffect(() => {
    if (typeof window === "undefined") return

    const tabId = crypto.randomUUID()
    sessionStorage.setItem(TAB_ID_KEY, tabId)

    const openTabs = JSON.parse(
      localStorage.getItem(OPEN_TABS_KEY) || "[]"
    )

    localStorage.setItem(
      OPEN_TABS_KEY,
      JSON.stringify([...new Set([...openTabs, tabId])])
    )

    const handleUnload = () => {
      const tabs = JSON.parse(
        localStorage.getItem(OPEN_TABS_KEY) || "[]"
      )

      const updatedTabs = tabs.filter(id => id !== tabId)
      localStorage.setItem(OPEN_TABS_KEY, JSON.stringify(updatedTabs))
    }

    window.addEventListener("beforeunload", handleUnload)

    return () => {
      handleUnload()
      window.removeEventListener("beforeunload", handleUnload)
    }
  }, [])

  useEffect(() => {
    const timeout = setTimeout(() => {
      const tabs = JSON.parse(
        localStorage.getItem(OPEN_TABS_KEY) || "[]"
      )

      if (tabs.length === 0) {
        signOut(auth)
        nookies.destroy(undefined, "token", { path: "/" })
        localStorage.removeItem(OPEN_TABS_KEY)
      }
    }, 500)
    return () => clearTimeout(timeout)
  }, [])
}
